import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

export const selectNbHits = (
  state: SpartacuxProductDiscoveryDomainState,
): number | undefined =>
  state.productDiscovery?.searchBar?.autoComplete?.products?.nbHits;
